import { Box, Typography } from '@mui/material';
import React from 'react';
import { AuthUser, UsersDTO } from '../../../redux/identity/identityTypes';
import { getActiveDatabaseName, getUserName } from './utils';
import UserAvatar, { getUserInitials } from './UserAvatar';

export { getUserInitials };

export interface UserBadgeProps {
	user: AuthUser | UsersDTO | null;
	isHorizontal?: boolean;
}

const isAuthUser = (user: AuthUser | UsersDTO | null): user is AuthUser => {
	return user !== null && 'databases' in user;
};

const UserBadge: React.FC<UserBadgeProps> = ({
	user,
	isHorizontal = false,
}) => {
	const userName = getUserName(user);
	const activeDatabase = isAuthUser(user) ? getActiveDatabaseName(user) : '';

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 2,
				flexDirection: isHorizontal ? 'row' : 'column',
				textAlign: isHorizontal ? 'left' : 'center',
			}}
		>
			<UserAvatar user={user} size={64} />
			<Box>
				<Typography
					sx={{
						fontSize: '18px',
						fontWeight: 500,
						color: (th) => th.palette.kemek.darkestGray,
					}}
				>
					{userName}
				</Typography>
				<Typography
					sx={{
						fontSize: '14px',
						color: (th) => th.palette.kemek.lightGray,
					}}
				>
					{activeDatabase}
				</Typography>
			</Box>
		</Box>
	);
};

export default UserBadge;

